import cashierService from 'modules/POS/services';
import ReceiptTicketUI from 'modules/POS/Receipts/TicketReceipts/ReceiptTicket';
import React from 'react';
type Props = {
  isPrinter?: boolean;
  billRef?: React.RefObject<HTMLDivElement>;
  owner?: boolean;
};
const TicketReceipt = ({ billRef, owner }: Props) => {
  const printerInfo = cashierService.selectors.printerInfo();
  return (
    <ReceiptTicketUI
      billRef={billRef}
      ticketDetail={printerInfo.detail}
      printer
      owner={owner}
      coupons={printerInfo.coupons}
    />
  );
};

export default TicketReceipt;
